import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { accentColors, secondaryColors } from '@tryhackme/thm-ui-components';
import styled, { css } from 'styled-components';

const iconStyles = css`
  font-size: 2.6rem;
`;

export const StyledContainer = styled.div<{ $isDarkMode: boolean; $hasVariedColumnWidths?: boolean }>`
  display: flex;
  gap: 2.4rem;
  flex-wrap: no-wrap;
  flex-direction: column;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: row;
  }

  ${(props) =>
    props.$hasVariedColumnWidths &&
    `
    @media screen and (min-width: ${props.theme.sizes.xl}) {
      > div:first-child,
      > div:last-child {
        min-width: max-content;
      }

      > div:nth-child(2) {
        width: unset;
      }
    }
  `}
`;

export const StyledStepNumber = styled.p<{ $isDarkMode: boolean }>`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  color: ${({ theme, $isDarkMode }) => ($isDarkMode ? theme.colors.grey[300] : theme.colors.grey[600])};
  text-transform: uppercase;
  margin-bottom: 1.2rem;
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    display: block;
  }
`;

export const StyledIcon = styled(FontAwesomeIcon)<{ $isDarkMode: boolean }>`
  ${iconStyles};
  color: ${({ theme, $isDarkMode }) => ($isDarkMode ? accentColors.info.dark : theme.colors.info.main)};
  grid-area: icon;
  margin: 0 0.8rem;
`;

export const StyledTitle = styled.p`
  grid-area: title;
  font-size: 2.2rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledDescription = styled.p<{ $isDarkMode: boolean }>`
  grid-area: description;
  color: ${({ $isDarkMode }) => ($isDarkMode ? secondaryColors.grey[100] : '#000')};
`;

export const StyledStepContainer = styled.div`
  display: grid;
  justify-content: flex-start;
  grid-gap: 0.8rem;
  grid-template-areas: 'icon title' '. description';
`;

export const StyledIconGrey = styled(FontAwesomeIcon)`
  ${iconStyles};
  align-self: center;
  color: ${({ theme }) => theme.colors.grey[500]};
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    display: block;
  }
`;
